import { t } from '@lingui/core/macro'
import { CvsAutoComplete } from '@components'
import { useCreativeClassifications } from '@global/hooks/queries/useCreativeClassifications'

const VISIBLE_OPTIONS = ['Content ID']

export function ContentComprehension({ form, setForm, disabled }) {
  const { data: classifications = [], isLoading } = useCreativeClassifications()
  const OPTIONS = classifications
    .filter(({ categoryText }) => VISIBLE_OPTIONS.includes(categoryText))
    .map(({ id, categoryText }) => ({ value: id, label: categoryText }))

  return (
    <div>
      <CvsAutoComplete
        label={t`Select CC type`}
        margin="dense"
        isLoading={isLoading}
        options={OPTIONS as never[]}
        disabled={disabled || isLoading || !OPTIONS.length}
        selected={form?.classification?.category_id}
        onSelected={item => {
          setForm({ ...form, classification: { ...form.classification, category_id: item } })
        }}
      />
    </div>
  )
}
